import React, { useEffect, useState } from "react";
import { FiShield } from "react-icons/fi";
import axiosInstance from "../../../axios/axios";
import { useParams } from "react-router-dom";
import moment from "moment";

import {
  Encrypt_Value,
  Decrypt_Value,
} from "../../../MiddleWare/EncryptDecrypt";

const HealthScreeningCard = ({ onExportData }) => {
  const { pid } = useParams();

  const [data, setData] = useState([]);

  const getStatusBadgeClass = (status) => {
    if (status === "Due") return "active-status";

    if (status === "OverDue") return "inactive-status";

    if (status === "Due Soon") return "warning-status";

    if (status === "Completed") return "resolved-status";

    return "";
  };

  useEffect(() => {
    if (!pid) return;

    fetchHealthScreening();
  }, [pid]);

  const fetchHealthScreening = async () => {
    try {
      const response = await axiosInstance.post(
        "/vozo/patient/preventive-screenings/list",

        Encrypt_Value(
          {
            patient_id: pid,
          },
          "vozo",
        ),
      );

      let result = Decrypt_Value(response.data, "vozo");

      if (typeof result === "string") {
        result = JSON.parse(result);
      }

      if (result?.Status === "Success") {
        const formattedData = (result.Data || []).map((item) => ({
          testName: item.testName || "-",

          age: item.age || "-",

          // dueDate:
          //   item.dueDate &&
          //   item.dueDate !== "0000-00-00" &&
          //   moment(item.dueDate).isValid()
          //     ? moment(item.dueDate).format("MMM DD, YYYY")
          //     : "",
          dueDate:
            item.dueDate && item.dueDate !== "0000-00-00"
              ? moment(item.dueDate, "DD/MM/YYYY").format("MMM DD, YYYY")
              : "",

          status: item.status || "-",
        }));

        /* UI → latest 3 */

        const latestThree = formattedData.slice(0, 3);

        setData(latestThree);

        /* PARENT → FULL DATA */

        if (onExportData) {
          onExportData(
            formattedData.map((item) => ({
              title: item.testName,
              age: item.age,
              due: item.dueDate,
              status: item.status,
            })),
          );
        }
      } else {
        setData([]);
      }
    } catch (error) {
      console.log("Health Screening API Error:", error);

      setData([]);
    }
  };

  return (
    <div className="care-summary-card">
      <div className="care-summary-title-wrap">
        <FiShield className="care-summary-main-icon" />

        <h3 className="care-summary-title">Health Screening</h3>
      </div>

      <div className="care-summary-body">
        {data.length === 0 ? (
          <div className="care-summary-empty">No health screenings Added</div>
        ) : (
          data.map((item, index) => (
            <div
              key={index}
              className={`care-summary-row ${
                index !== data.length - 1 ? "care-summary-border" : ""
              }`}
            >
              <div className="care-summary-content">
                <div className="care-summary-heading">{item.testName}</div>

                <div className="care-summary-subtext dark-sub">
                  Age: {item.age}
                </div>

                <div className="care-summary-subtext">
                  Due Date: {item.dueDate}
                </div>
              </div>

              <div
                className={`care-summary-status-wrap ${getStatusBadgeClass(
                  item.status,
                )}`}
              >
                <span className="care-summary-status-dot"></span>

                <span className="care-summary-status-text">{item.status}</span>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default React.memo(HealthScreeningCard);
